var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOffMic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icOffMic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons-states",
    transform: "translate(-211.000000, -340.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(57.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(140.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icOffMic",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "turn-microphone-off-button",
    transform: "translate(4.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333043,10.3029014 L4.66665214,3.58361787 L4.66665214,3.35964175 C4.66665214,1.45584476 6.11109344,0 7.99997821,0 C9.88886299,0 11.3333043,1.45584476 11.3333043,3.35964175 L11.3333043,10.0789252 C11.3333043,10.1909133 11.3333043,10.1909133 11.3333043,10.3029014 Z M4.66665214,8.80932617 L12.2458496,16.3855794 C11.4680735,16.8334877 10.1111283,17.4701371 9.11113048,17.5821252 L9.11113048,21.2777311 L6.8889131,21.2777311 L6.8889131,17.5821252 C3.22225442,17.0221849 0.222260954,13.8865192 0.222260954,10.0789252 L2.2222566,10.0789252 C2.2222566,13.438567 5.00002832,15.7903162 8.11113266,15.7903162 C9.00001961,15.7903162 10.0793581,15.3794928 10.8571777,15.0435286 L9.11113048,13.2057292 C8.77779787,13.3177172 8.22219995,13.438567 7.99997821,13.438567 C6.11109344,13.438567 4.66665214,11.9827222 4.66665214,10.0789252 L4.66665214,8.80932617 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    transform: "translate(12.020815, 12.020815) rotate(-45.000000) translate(-12.020815, -12.020815) ",
    x: 11.0208153,
    y: -3.97918472,
    width: 2,
    height: 32,
    rx: 1
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOffMic);
export default __webpack_public_path__ + "static/media/icOffMic.35965c1aacb5ea4315fc5500e07839a2.svg";
export { ForwardRef as ReactComponent };